import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { isAthlete } from "../utils/auth";
import { fetchAdvertisingContent } from "../services/advertisingService";
import { AdvertisingContent } from "../types/advertising";
import "../styles/athlete-admin-layout.css";
import "../styles/advertising-page.css";

export default function AdvisingPage() {
    const { athleteId } = useParams<{ athleteId?: string }>();
    const [content, setContent] = useState<AdvertisingContent | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    // Check if current user is admin/staff viewing an athlete
    const isAdminViewingAthlete = !isAthlete() && athleteId;


    useEffect(() => {
        const loadContent = async () => {
            try {
                setLoading(true);
                setError(null);
                const data = await fetchAdvertisingContent();

                // Get the first item from the array (or find by slug if needed)
                if (data && data.length > 0) {
                    setContent(data[0]);
                } else {
                    setError("No advertising content available");
                }
            } catch (err) {
                console.error("Failed to load advertising content:", err);
                setError("Failed to load content. Please try again later.");
            } finally {
                setLoading(false);
            }
        };

        loadContent();
    }, []);

    if (loading) {
        return (
            <div className={`advertising-page ${isAdminViewingAthlete ? 'with-athlete-sidebar' : ''}`}>
                <div className="advertising-loading">
                    <div className="advertising-spinner" role="status" aria-label="Loading content"></div>
                </div>
            </div>
        );
    }

    if (error || !content) {
        return (
            <div className={`advertising-page ${isAdminViewingAthlete ? 'with-athlete-sidebar' : ''}`}>
                <div className="advertising-error">
                    <p>{error || "Content not available"}</p>
                </div>
            </div>
        );
    }

    return (
        <div className={`advertising-page ${isAdminViewingAthlete ? 'with-athlete-sidebar' : ''}`}>
            {/*<h1>{content.title}</h1>*/}

            <div className="advertising-content">
                <div className="advertising-header">
                    <div className="advertising-header-top">
                        <a
                            href={content.buttonUrl}
                            className="advertising-logo-link"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label={`Visit ${content.buttonLabel}`}
                        >
                            <div className="advertising-logo">
                                <img
                                    src={content.topGraphicBlock}
                                    alt="Polaris Student Athlete Consulting Logo"
                                />
                            </div>
                        </a>
                    </div>
                </div>

                <div className="advertising-main-graphic">
                    <img
                        src={content.bottomGraphicBlock}
                        alt="Polaris Advising Services"
                    />
                </div>
            </div>
        </div>
    );
}

